const versionNumber = "2.5.6";

export default versionNumber;
